import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {Text, View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";

export default function QuoteModule(): React.ReactElement {
    return (
        <View style={styles.content}>
            <q className={css(styles.quote)}>
                {t`“It was a lot less stressful than the paper SAT because of it being only around 2 hours and because you don’t have to bubble answers anymore which was quite tedious before.”`}
            </q>
            <Text style={styles.quoteSource}>
                {t`Sarah O. | Casablanca, Morocco`}
            </Text>
            <Text style={styles.quoteSource}>
                {t`Digital SAT Pilot Student`}
            </Text>
        </View>
    );
}

const styles = StyleSheet.create({
    content: {
        backgroundColor: color.offWhite,
        alignItems: "center",
        paddingTop: 72,
        paddingBottom: 72,
        paddingLeft: spacing.xLarge_32,
        paddingRight: spacing.xLarge_32,
        [mediaQueries.smOrSmaller]: {
            paddingTop: spacing.xxxLarge_64,
            paddingBottom: spacing.xxxLarge_64,
        },
    },
    quote: {
        color: "black",
        fontFamily: "Source Serif Pro",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        fontSize: 32,
        lineHeight: "43px",
        marginBottom: 42,
        width: "100%",
        maxWidth: 1029,
        [mediaQueries.smOrSmaller]: {
            fontSize: 30,
            lineHeight: "36px",
        },
    },
    quoteSource: {
        textAlign: "right",
        width: "100%",
        maxWidth: 910,
        fontSize: 16,
        lineHeight: "25px",
        letterSpacing: "0.1em",
        fontWeight: "bold",
    },
});
